import {getSubjectSignaturesInfo} from "../../domains/sign";

/**
 * Ответ по выпуску подписи клиента (SignMe)
 * @typedef {Object} SignMeIssueSignature
 * @property {string} registrationBlank Ссылка на бланк регистрации (PDF)
 * @property {Precheck} precheck Результат предварительной проверки
 * @property {UserInfo} userinfo Информация о пользователе
 * @property {boolean} documentsAlreadySentToCA Документы уже отправлены в УЦ
 * @property {IssueDocs} issueDocs Загруженные документы
 */

/**
 * @typedef {Object} Precheck
 * @property {number} id
 * @property {boolean} created
 * @property {boolean} rejected
 * @property {boolean} approved
 * @property {number} apprtype Тип подтверждения
 * @property {string} reject_comment Комментарий отказа
 * @property {string} active_at Дата активации (ISO)
 * @property {Array<*>} keys
 * @property {Array<*>} auth_keys
 * @property {boolean} mine
 * @property {string} pdf Ссылка на PDF
 * @property {Array<PrecheckRequest>} requests Запросы на выпуск
 * @property {SmevChecks} smev Проверки через СМЭВ
 */

/**
 * @typedef {Object} PrecheckRequest
 * @property {number} id
 * @property {string} num UUID запроса
 * @property {boolean} mobile
 * @property {string} error
 * @property {string} ca Удостоверяющий центр
 * @property {number} apprtype
 */

/**
 * @typedef {Object} SmevChecks
 * @property {SmevItem} snils
 * @property {SmevItem} inn
 * @property {SmevItem} passport
 */

/**
 * @typedef {Object} SmevItem
 * @property {string} status
 * @property {string} details
 * @property {string} date
 */

/**
 * @typedef {Object} UserInfo
 * @property {number} id
 * @property {string} fio ФИО
 * @property {string} phone
 * @property {string} snils
 * @property {string} haspdf Ссылка на PDF/изображение
 * @property {boolean} haspas Есть паспорт (страница)
 * @property {boolean} haspas2 Есть вторая страница паспорта
 * @property {boolean} hasnils Есть СНИЛС
 * @property {boolean} hasface Есть фото лица
 * @property {Array<*>} keys
 * @property {Array<*>} delivery
 * @property {Array<*>} identification
 */

/**
 * @typedef {Object} IssueDocs
 * @property {string|null} passportPhotoPage
 * @property {string|null} passportPhotoPageLink
 * @property {string|null} snils
 * @property {string|null} snilsLink
 * @property {string|null} issueStatement
 * @property {string|null} issueStatementLink
 * @property {string|null} inn
 * @property {string|null} innLink
 * @property {string|null} passportRegistration
 * @property {string|null} passportRegistrationLink
 * @property {string|null} subjectPhotoWStatement
 * @property {string|null} subjectPhotoWStatementLink
 */

/**
 * Элемент массива подписей от разных провайдеров
 * @typedef {Object} ParticipantSignature
 * @property {number} subjectId Провайдер подписи signme или mydss
 * @property {SignMeIssueSignature|null} signme Данные SignMe
 */

/** @type {ParticipantSignature[]} */
export let participantsSignatures = [];

export const getParticipantsSignatures = async ({subjectId}) => {
  const result = participantsSignatures.find((item) => item.subjectId === subjectId);

  if(result)
    return result

  const response = await getSubjectSignaturesInfo(subjectId);

  if (response.ok) {
    const signs = {
      subjectId,
      signme: response.data?.signme || null,
      mydss: response.data?.mydss || null,
    };

    participantsSignatures.push(signs);

    return signs;
  } else {
    return null;
  }
}

export const updateSignmeParticipantsData = ({ data, subjectId }) => {
  participantsSignatures.map(item => {
    if (item.subjectId === subjectId) {
      item.signme = {...item.signme, ...data}
    }
  });
};

export const updateMydssParticipantsData = ({ data, subjectId }) => {
  participantsSignatures.map(item => {
    if (item.subjectId === subjectId) {
      item.mydss = {...item.mydss, ...data}
    }
  });
};